<div
  [ngClass]="{'border-bottom-0': hideBorder}"
  class="row py-2 pt-md-0 pb-md-4 contract-item-container"
  data-e2e="contracts-options"
>
  <div class="col-12 col-md-6 col-lg-5">
    <h2 class="h3 mb-0" data-e2e="offerName">{{multiContractViewModel?.offerName}}</h2>
    <div class="lead text-gray3">{{multiContractViewModel?.detail}}</div>
  </div>
  <div class="col-12 col-md-6 col-lg-7 mt-1 mt-md-0 btn-center">
    @for (message of multiContractViewModel?.messages; track message) {
    <p class="text-left text-mw">{{message}}</p>
    } @if (multiContractViewModel?.linkInternet || multiContractViewModel.eSimLink) {
    <div class="d-flex justify-content-center justify-content-md-start">
      <div class="d-flex flex-column">
        <a
          class="btn btn-secondary"
          [href]="multiContractViewModel?.linkInternet | link | async"
          (click)="openBillMultiContract(multiContractViewModel?.linkInternet);false"
        >
          {{multiContractViewModel.button}}</a
        >
        @if (multiContractViewModel.eSimLink) {
        <a
          class="btn btn-secondary mt-2"
          [href]="multiContractViewModel.eSimLink | link | async"
          (click)="openBillButtonESimLink(multiContractViewModel.eSimLink);false"
        >
          {{"dashboard.contractsAndOptions.multiContract.parnasse.eSimLabel" | translate}}
        </a>
        }
      </div>
    </div>
    }
  </div>
</div>
